import { default as module } from './AbstractModule';
import modularLoad from 'modularload';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        html.classList.add('is-first-load');

        const load = new modularLoad({
            enterDelay: 600,
            transitions: {
                customTransition: {},
                filter: {},
            },
        });

        const classesToRemoveOnLoading = [
            'has-announcement-bar',
            'has-dark-header',
            'has-intro-active',
            'has-intro-dark',
            'has-intro-light-logo',
            'has-middle-line',
            'has-white-logo',
            'is-over-footer',
        ];

        load.on('loading', () => {
            window.isloading = true;

            setTimeout(() => {
                this.call('close', null ,'Nav');
            }, 100);

            for (let htmlClass of classesToRemoveOnLoading) {
                html.classList.remove(htmlClass);
            }
        })

        load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            document.title = document.title.replace(/&amp;/g, '&');

            let id = this.getData('id', newContainer);
            this.call('setDotById', id, 'Navmain', 'main');

            window.isloading = false;
        });

        load.on('ready', (transition, newContainer) => {
            let classes = this.getData('classes', newContainer);
            if (classes.length) {
                for (let htmlClass of classes.split(/\s+/)) {
                    html.classList.add(htmlClass);
                }
            }
        })
    }
}
